import {
  format,
  getYear,
  isAfter,
  isBefore,
  isSameDay,
  isWithinInterval,
  parse,
  parseISO,
} from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const ONE_MINUTE = 60000;

export const isBetweenUTC = (
  dateFrom: string | null,
  dateTo: string | null,
  checkTime?: string | null
) => {
  const from = dateFrom ? toZonedTime(parseISO(dateFrom), 'UTC') : null;
  const to = dateTo ? toZonedTime(parseISO(dateTo), 'UTC') : null;

  if (!from || !to) return false;

  if (checkTime) {
    const check = toZonedTime(parseISO(checkTime), 'UTC');
    return !isBefore(check, from) && !isAfter(check, to);
  }

  const now = new Date();
  return !isBefore(now, from) && !isAfter(now, to);
};

export function sortByDate<T>(a: T, b: T, key: keyof T) {
  const dateA = new Date((a[key] as any).toString()).getTime();
  const dateB = new Date((b[key] as any).toString()).getTime();
  return dateA < dateB ? 1 : -1;
}

export function timestampByUTC(time?: Date | string) {
  const date = time ? new Date(time) : new Date();
  return toZonedTime(date, 'UTC').getTime();
}

export function timestamp(time?: string) {
  return time ? new Date(time).getTime() : new Date().getTime();
}

export const isTimeLeft = (from: number, diff: number) =>
  timestampByUTC() - from > diff;

export const formatDateTime =
  (formatString = 'dd.MM.yyyy, HH:mm') =>
  (date: string | Date) => {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    return format(parsedDate, formatString);
  };

export const compareDates = (date1: string, date2: string): boolean => {
  const parsedDate1 = parseISO(date1);
  const parsedDate2 = parseISO(date2);
  return (
    isSameDay(parsedDate1, parsedDate2) || isAfter(parsedDate1, parsedDate2)
  );
};

export const currentFullYear = getYear(new Date());

export const isPromoAvailableDate = (start?: string, end?: string) => {
  if (!start || !end) return false;

  const today = toZonedTime(new Date(), 'UTC');
  const startDate = toZonedTime(new Date(start), 'UTC');
  const endDate = toZonedTime(new Date(end), 'UTC');
  return isWithinInterval(today, { start: startDate, end: endDate });
};

export const parseSoftSwissFormatDate = (date: string) => {
  return parse(date, "yyyy-MM-dd HH:mm:ss 'UTC'", new Date());
};
